(function (Drupal) {
  Drupal.behaviors.selectlanguage = {
    attach: function (context, settings) {
      const nav = document.querySelector('.links.nav.links-inline', context);

      if (!nav) {
        // Si el elemento nav no se encuentra, salimos de la función
        return;
      }
    
      const links = nav.querySelectorAll('a');
      const languageSelect = document.createElement('select');
      languageSelect.id = 'language-select';

      const customDiv = document.createElement('div');
      customDiv.className = 'element-custom';
      
      const selectedText = document.createElement('span');
      customDiv.appendChild(selectedText);

      links.forEach(link => {
        const opt = document.createElement('option');
        opt.value = link.href;
        opt.textContent = link.getAttribute('hreflang') || link.textContent;
        if (link.classList.contains('is-active')) {
          opt.selected = true;
          selectedText.textContent = opt.textContent;
          selectedText.className = opt.textContent;
        }
        opt.classList.add(link.textContent.toLowerCase().replace(/\s+/g, '-'));
        languageSelect.appendChild(opt);
      });

      languageSelect.addEventListener('change', function() {
        window.location.href = this.value;
        const selectedOption = this.options[this.selectedIndex];
        selectedText.textContent = selectedOption.textContent;
      });

      nav.parentNode.replaceChild(languageSelect, nav);

      languageSelect.parentNode.insertBefore(customDiv, languageSelect);
    }
  };
})(Drupal);
